
import { supabase } from "@/integrations/supabase/client";

// List of MIME types supported by Gemini for direct analysis
export const SUPPORTED_ANALYSIS_FORMATS = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/heic",
  "image/heif",
  "application/pdf"
] as const;

/**
 * Checks if a file type is supported for AI analysis
 */
export function isAnalysisSupported(mimeType: string): boolean {
  return SUPPORTED_ANALYSIS_FORMATS.includes(mimeType as any);
}

/**
 * Prepares document data for the Gemini API
 * @param fileData File data as ArrayBuffer
 * @param mimeType MIME type of the file
 * @returns Object with data and MIME type for Gemini API
 */
export async function prepareDocumentForAI(fileData: ArrayBuffer, mimeType: string): Promise<{ data: string, mimeType: string }> {
  if (!isAnalysisSupported(mimeType)) {
    throw new Error(`File type ${mimeType} is not supported for AI analysis. Please convert to PDF or use a supported image format.`);
  }
  
  // Convert to base64 for supported types
  const base64Data = arrayBufferToBase64(fileData);
  return { data: base64Data, mimeType };
}

/**
 * Convert ArrayBuffer to Base64 string
 */
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

/**
 * Convert Unicode string to Base64
 */
export function unicodeToBase64(text: string): string {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(text);
  let binaryString = '';
  for (let i = 0; i < bytes.length; i++) {
    binaryString += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binaryString);
}

